export const URL_API =
  process.env.REACT_APP_API_URL || "http://localhost/v1/";
